import React from "react";
import Types from "prop-types";
import { ReCaptcha } from "../../Guard";
import { Helmet } from "react-helmet";
import AppleButton from "../../common/AppleButton";
import eventAnalytics from "../../../analytikaV2";
import { ANALYTIKA_EVENTS } from "../../../utils/constants";

export default class AppleLoginForm extends React.Component {
  constructor(props) {
    super(props);
    eventAnalytics.setPageName(ANALYTIKA_EVENTS.PAGE.APPLE_LOGIN_FORM);
    eventAnalytics.publishViewPage(ANALYTIKA_EVENTS.PAGE.APPLE_LOGIN_FORM);
  }

  render() {
    const { error, onAppleTokenChanged } = this.props;
    return (
      <form>
        <Helmet>
          <title>Login | Careem</title>
        </Helmet>

        {error && <div className="invalid show">{error}</div>}
        <div className="center">
          <AppleButton onChange={onAppleTokenChanged} />
        </div>

        <ReCaptcha />
      </form>
    );
  }
}

AppleLoginForm.propTypes = {
  onAppleTokenChanged: Types.func.isRequired,
};
